import * as React from "react";
import createEventPublisher from "../lib/events/EventPublisher";
import { onEvent } from "../messages";
import useAppSelector from "./useAppSelector";
export default function useEventPublisher() {
    var userId = useAppSelector(function (state) { return state.configuration; }).userId;
    return React.useMemo(function () { return createEventPublisher(onEvent, userId); }, [userId]);
}
